import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import SiteSwitcher from "../DistributorDashboard/SiteSwitcher";
import { getDistributorActions } from "../../../config/actions";
import { Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastBody } from "reactstrap";
import "../../css/QuickActions.css";
import "./MiniCart.css";
import { API_URL } from "../../../config";
import { getActiveSiteId } from "../../../utils/site";


const MiniCart = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const userId = localStorage.getItem("user_id");
  const [siteId, setSiteId] = useState(localStorage.getItem("site_id"));

  // if (userType !== "6") {
  //   navigate("/");
  //   return null;
  // }

  const [isOnboarding, setIsOnboarding] = useState(true);
  const [collectorTax, setCollectorTax] = useState(null);
  const [taxSaved, setTaxSaved] = useState(false);

  const [distributorCountry, setDistributorCountry] = useState(null);
  const [taxSettings, setTaxSettings] = useState({});
  const [selectedStates, setSelectedStates] = useState([]);
  const [systems, setSystems] = useState([]);
  const [showTaxModal, setShowTaxModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [originalLanguage, setOriginalLanguage] = useState("en");
  const [originalCurrency, setOriginalCurrency] = useState("USD");
  const [savingLanguage, setSavingLanguage] = useState(false);
  const [savingCurrency, setSavingCurrency] = useState(false);

  const [paymentGateway, setPaymentGateway] = useState("paypal");
  const [paymentCredentials, setPaymentCredentials] = useState({
    paypal_client_id: "",
    stripe_publishable_key: "",
    stripe_secret_key: "",
    custom_gateway_name: "",
    mollie_api_key: ""
  });

  
  const [txnStats, setTxnStats] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [showPricesModal, setShowPricesModal] = useState(false);
  const [systemPrices, setSystemPrices] = useState({});
  const [systemEnabled, setSystemEnabled] = useState({});
    // console.log(paymentCredentials,systemPrices);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [availableSystems, setAvailableSystems] = useState([]);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [savingPayment, setSavingPayment] = useState(false);
  const [showPaypalOnboarding, setShowPaypalOnboarding] = useState(false);
  const [showStripePublishable, setShowStripePublishable] = useState(false);
  const [showStripeSecret, setShowStripeSecret] = useState(false);
  const [showPaypalClientId, setShowPaypalClientId] = useState(false);
  const [showMollieApiKey, setShowMollieApiKey] = useState(false);
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [shippingSettings, setShippingSettings] = useState({ domestic_shipping: "", international_shipping: "" });
  const [savingShipping, setSavingShipping] = useState(false);
  const [txnLoaded, setTxnLoaded] = useState(false);




  const fetchDistributorByMD5 = async (resolvedSiteId) => {
    const id = resolvedSiteId ?? siteId;
    if (!id || !userId) return;
    try {
      const [sitesRes, distributorRes] = await Promise.all([
        fetch(`${API_URL}/distributor/site/${userId}`, {
          headers: { "x-access-token": localStorage.getItem("accessToken") },
        }).then((r) => r.json()),
        fetch(`${API_URL}/get/distributer/by/md5/${userId}`).then((r) => r.json()),
      ]);

      const data = sitesRes.status && Array.isArray(sitesRes.data)
        ? sitesRes.data.find((s) => s.site_id === id)
        : null;
      // The distributor's own business-address country (set at signup) is the
      // default until this site's tax settings have been explicitly saved.
      const distributorAddressCountry = distributorRes.status && distributorRes.data
        ? distributorRes.data.country
        : null;
      if (data) {

        // Payment settings — flat DB columns
        if (data.payment_gateway) {
          setPaymentGateway(data.payment_gateway);
        }
        setPaymentCredentials({
          paypal_client_id: data.paypal_client_id || "",
          stripe_publishable_key: data.stripe_publishable_key || "",
          stripe_secret_key: data.stripe_secret_key || "",
          custom_gateway_name: data.custom_gateway_name || "",
          mollie_api_key: data.mollie_api_key || ""
        });

        // Language & Currency — flat DB columns
        if (data.selected_language) setSelectedLanguage(data.selected_language);
        if (data.selected_currency) setSelectedCurrency(data.selected_currency);

        // Shipping settings
        setShippingSettings({
          domestic_shipping: data.domestic_shipping ?? "",
          international_shipping: data.international_shipping ?? ""
        });

        // Global tax (fallback)
        // if (data.global_tax !== undefined && data.global_tax !== null) {
        //   setTaxSettings(prev => ({ ...prev, globalTax: parseFloat(data.global_tax) }));
        // }

        // Distributor country + per-state tax settings — the site's own
        // tax_country (once explicitly saved) wins, otherwise fall back to
        // the distributor's business-address country.
        const effectiveCountry = data.tax_country || distributorAddressCountry;
        if (effectiveCountry) {
          setDistributorCountry(effectiveCountry);
          setCollectorTax(true);
          setIsOnboarding(false);
        }
        if (data.tax_settings) {
          try {
            const states = typeof data.tax_settings === "string"
              ? JSON.parse(data.tax_settings)
              : data.tax_settings;
            if (Array.isArray(states) && states.length > 0) {
              if (effectiveCountry === "231") {
                setSelectedStates(states.map(s => s.code));
                const taxMap = {};
                states.forEach(s => { taxMap[s.code] = s.tax; });
                setTaxSettings(prev => ({ ...prev, ...taxMap }));
              } else {
                const globalEntry = states.find(s => s.code === "OTHER");
                if (globalEntry) {
                  setTaxSettings(prev => ({ ...prev, globalTax: globalEntry.tax }));
                }
              }
            }
          } catch (e) {
            console.error("Error parsing tax_settings:", e);
          }
        }

        // Skip onboarding if payment gateway is already configured
        // if (data.payment_gateway) {
        //   setTaxSaved(true);
        //   setIsOnboarding(false);
        // }
      }
    } catch (error) {
      console.error("Error fetching distributor data:", error);
    }
  };

  const handleSavePaymentSettings = async () => {
    if (paymentGateway === "stripe" && (!paymentCredentials.stripe_publishable_key.trim() || !paymentCredentials.stripe_secret_key.trim())) {
      showToast("Please enter both Stripe keys", "error");
      return;
    }
    if (paymentGateway === "paypal" && !paymentCredentials.paypal_client_id.trim()) {
      showToast("Please enter PayPal Client ID", "error");
      return;
    }
    if (paymentGateway === "custom" && !paymentCredentials.custom_gateway_name.trim()) {
      showToast("Please enter gateway name", "error");
      return;
    }
    if (paymentGateway === "mollie" && !paymentCredentials.mollie_api_key.trim()) {
      showToast("Please enter Mollie API Key", "error");
      return;
    }

    setSavingPayment(true);
    try {
      const response = await fetch(`${API_URL}/update-distributor-payment-method/${siteId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          payment_gateway: paymentGateway,
          paypal_client_id: paymentCredentials.paypal_client_id,
          stripe_publishable_key: paymentCredentials.stripe_publishable_key,
          stripe_secret_key: paymentCredentials.stripe_secret_key,
          custom_gateway_name: paymentCredentials.custom_gateway_name,
          mollie_api_key: paymentCredentials.mollie_api_key
        })
      });
      const data = await response.json();
      if (data.status) {
        setShowPaymentModal(false);
        showToast("Payment settings updated successfully!", "success");
      } else {
        showToast(data.message || "Failed to save payment settings", "error");
      }
    } catch (error) {
      console.error("Error saving payment settings:", error);
      showToast("Failed to save payment settings", "error");
    } finally {
      setSavingPayment(false);
    }
  };

  const handleSaveShippingSettings = async () => {
    setSavingShipping(true);
    try {
      const response = await fetch(`${API_URL}/distributor/shipping-settings/${siteId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          domestic_shipping: parseInt(shippingSettings.domestic_shipping) || 0,
          international_shipping: parseInt(shippingSettings.international_shipping) || 0
        })
      });
      const data = await response.json();
      if (data.status) {
        setShowShippingModal(false);
        showToast("Shipping settings updated successfully!", "success");
      } else {
        showToast(data.message || "Failed to save shipping settings", "error");
      }
    } catch (error) {
      console.error("Error saving shipping settings:", error);
      showToast("Failed to save shipping settings", "error");
    } finally {
      setSavingShipping(false);
    }
  };

  useEffect(() => {
    fetchAllSystem();
    getActiveSiteId().then((resolvedSiteId) => {
      setSiteId(resolvedSiteId);
      fetchDistributorByMD5(resolvedSiteId);
    });
    fetchTxnStats();
  }, []);

  useEffect(() => {
    if (availableSystems.length > 0 && siteId) {
      fetchPricesFromAPI();
    }
  }, [availableSystems.length, siteId]);
  

  // State tax options
  const usStates = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

const fetchAllSystem = async () => {
  try {
    const [res22, res24] = await Promise.all([
      fetch(`${API_URL}/get/specified/product/by/22`).then(r => r.json()),
      fetch(`${API_URL}/get/specified/product/by/24`).then(r => r.json()),
    ]);

    const systems = [
      ...(res22.data || []).map(s => ({ ...s, category: 22 })),
      ...(res24.data || [])
        .filter(s => s.id !== 137) // Hide product ID 137 from category 24
        .map(s => ({ ...s, category: 24 })),
    ];

    // Add Modules product if not already present
    const modulesProduct = { id: 135, name: "Modules" };
    const hasModules = systems.some(s => s.id === 135);

    if (!hasModules) {
      systems.push(modulesProduct);
    }

    setAvailableSystems(systems);
  } catch (error) {
    console.log(error);
  }
};

  // const availableSystems = [
  //   { id: "basic", name: "CapnoGO™ Basic System", description: "Entry-level system" },
  //   { id: "esports", name: "CapnoGO™ E-sports System", description: "For esports teams" },
  //   { id: "advanced", name: "CapnoGO™ Advanced System", description: "Advanced features" },
  //   { id: "professional", name: "CapnoGO™ Professional System", description: "Professional grade" },
  //   { id: "group", name: "CapnoGO™ Group System", description: "Group training" },
  //   { id: "upgrades", name: "System Upgrades", description: "Upgrade packages" }
  // ];

  const handleTaxCollectionChoice = async (choice) => {
    setCollectorTax(choice);
    if (!choice) {
      setDistributorCountry(null);
      setTaxSettings({});
      setSelectedStates([]);
      try {
        await fetch(`${API_URL}/distributor/tax-settings/${siteId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country: null, states: [] })
        });
      } catch (err) {
        console.error("Error clearing tax settings:", err);
      }
      setIsOnboarding(false);
    }
  };

  const handleCountrySelect = (country) => {
    setDistributorCountry(country);
    setSelectedStates([]);
    setTaxSettings({});
  };

  const handleAddState = (state) => {
    if (!selectedStates.includes(state)) {
      setSelectedStates([...selectedStates, state]);
      setTaxSettings(prev => ({
        ...prev,
        [state]: 0
      }));
    }
  };

  const handleRemoveState = async (state) => {
    const newSelectedStates = selectedStates.filter(s => s !== state);
    const newTaxSettings = { ...taxSettings };
    delete newTaxSettings[state];

    setSelectedStates(newSelectedStates);
    setTaxSettings(newTaxSettings);

    try {
      const states = distributorCountry === "231"
        ? newSelectedStates.map(s => ({ code: s, tax: newTaxSettings[s] || 0 }))
        : [{ code: "OTHER", tax: newTaxSettings.globalTax || 0 }];

      await fetch(`${API_URL}/distributor/tax-settings/${siteId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: distributorCountry, states })
      });
    } catch (err) {
      console.error("Error removing state tax setting:", err);
    }
  };

  const handleTaxChange = (stateOrKey, value) => {
    setTaxSettings(prev => ({
      ...prev,
      [stateOrKey]: parseFloat(value) || 0
    }));
  };

  const buildTaxStatesPayload = () => {
    if (distributorCountry === "231") {
      return selectedStates.map(s => ({ code: s, tax: taxSettings[s] || 0 }));
    }
    return [{ code: "OTHER", tax: taxSettings.globalTax || 0 }];
  };

  const handleCompleteTaxSetup = async () => {
    try {
      await fetch(`${API_URL}/distributor/tax-settings/${siteId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: distributorCountry, states: buildTaxStatesPayload() })
      });
    } catch (err) {
      console.error("Error saving tax settings:", err);
    }
    setTaxSaved(true);
  };

  const handlePaypalSetup = async () => {
    if (!paymentCredentials.paypal_client_id.trim()) {
      alert("Please enter a valid PayPal Client ID");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/update-distributor-payment-method/${siteId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          payment_gateway: "paypal",
          paypal_client_id: paymentCredentials.paypal_client_id
        })
      });
      const data = await response.json();
      if (!data.status) {
        console.error("Failed to save payment settings:", data.message);
      }
    } catch (error) {
      console.error("Error saving payment settings:", error);
    }

    // if (availableSystems.length > 0) {
    //   await handleAutoEnableAllSystems();
    // }

    setIsOnboarding(false);
  };


  const handlePriceChange = (systemId, price) => {
    setSystemPrices(prev => ({
      ...prev,
      [systemId]: parseFloat(price) || 0
    }));
  };

  const handleToggleEnabled = async (systemId) => {
    const currentlyEnabled = systemEnabled[systemId] !== false;
    const nextEnabled = !currentlyEnabled;
    const previousPrice = systemPrices[systemId];

    setSystemEnabled(prev => ({ ...prev, [systemId]: nextEnabled }));
    if (!nextEnabled) {
      setSystemPrices(prev => ({ ...prev, [systemId]: 0 }));
    }

    try {
      const response = await fetch(
        `${API_URL}/distributor/pricing/${nextEnabled ? "enable" : "disable"}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            product_id: Number(systemId),
            site_id: siteId,
          }),
        }
      );

      const data = await response.json();

      if (!data.status) {
        throw new Error(data.message || "Failed to update system status");
      }

      showToast(nextEnabled ? "System enabled" : "System disabled", "success");
    } catch (error) {
      console.error("Error toggling system status:", error);
      showToast("Failed to update system status: " + error.message, "error");
      setSystemEnabled(prev => ({ ...prev, [systemId]: currentlyEnabled }));
      if (!nextEnabled) {
        setSystemPrices(prev => ({ ...prev, [systemId]: previousPrice }));
      }
    }
  };
// console.log(userId);

//  const handleAutoEnableAllSystems = async () => {
//   try {
//     const pricesArray = availableSystems.map((system) => ({
//       product_id: Number(system.id),
//       distributor_id: userId,
//       price: 0,
//     }));

//     const response = await fetch(
//       `${API_URL}/distributor/pricing/bulk-set`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           prices: pricesArray,
//         }),
//       }
//     );

//     const data = await response.json();

//     if (response.ok && data.status) {
//       console.log("All systems enabled successfully");
//     } else {
//       console.error(data.message || "Failed to enable systems");
//     }
//   } catch (error) {
//     console.error("Error auto-enabling systems:", error);
//   }
// };

  const showToast = (message, type = "success") => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => setToastMessage(""), 4000);
  };

  const getCurrencySymbol = (code) => {
    const symbols = {
      USD: "$", EUR: "€", GBP: "£", JPY: "¥", CNY: "¥", INR: "₹",
      BRL: "R$", MXN: "$", CAD: "$", AUD: "$", NZD: "$", CHF: "Fr",
      SGD: "$", HKD: "$", KRW: "₩", THB: "฿", MYR: "RM", IDR: "Rp",
      PHP: "₱", VND: "₫", ZAR: "R", TRY: "₺", RUB: "₽", PLN: "zł",
      CZK: "Kč", HUF: "Ft", RON: "lei", BGN: "лв", HRK: "kn",
      SEK: "kr", NOK: "kr", DKK: "kr", ILS: "₪", AED: "د.إ",
      SAR: "﷼", ARS: "$", CLP: "$", COP: "$", PEN: "S/", UYU: "$U",
      EGP: "£", NGN: "₦"
    };
    return symbols[code] || code;
  };

    const fetchTxnStats = async () => {


    try {
      const distributor_id = localStorage.getItem("user_id");

      const res = await fetch(`${API_URL}/txn/${distributor_id}`);
  
      const response = await res.json();
     
      setTxnStats(response)
    } catch (error) {
      console.error("Error fetching txn:", error);
    } finally {
      setTxnLoaded(true);
    }
  };

  const fetchPricesFromAPI = async () => {
    setLoadingPrices(true);
    try {
      const response = await fetch(
        `${API_URL}/distributor/pricing/status-all?site_id=${siteId}`
      );

      const data = await response.json();

      const byProductId = {};
      if (data.status && Array.isArray(data.data)) {
        data.data.forEach((entry) => {
          byProductId[entry.product_id] = entry;
        });
      }

      const pricesData = {};
      const enabledData = {};

      for (const system of availableSystems) {
        const entry = byProductId[system.id];
        if (entry && entry.price) {
          pricesData[system.id] = entry.price;
        }
        enabledData[system.id] = entry ? entry.enabled !== false : true;
      }

      if (Object.keys(pricesData).length > 0) {
        setSystemPrices(pricesData);
      }
      setSystemEnabled(enabledData);
    } catch (error) {
      console.error("Error fetching prices from API:", error);
      showToast("Failed to load prices from server", "error");
    } finally {
      setLoadingPrices(false);
    }
  };

  const handleSavePrices = async () => {
    const pricesArray = availableSystems.map(system => {
      const enabled = systemEnabled[system.id] !== false;
      return {
        product_id: Number(system.id),
        site_id: siteId,
        price: enabled ? parseFloat(systemPrices[system.id] || 0) : 0,
        enabled,
      };
    });

    try {
      const response = await fetch(`${API_URL}/distributor/pricing/bulk-set`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prices: pricesArray,
        }),
      });

      const data = await response.json();

      if (data.status) {
        setShowPricesModal(false);

        const failedCount = data.data.failed ? data.data.failed.length : 0;
        if (failedCount === 0) {
          showToast(`All ${data.data.total} system price(s) updated successfully!`, "success");
        } else {
          showToast(
            `${data.data.success.length} price(s) updated, but ${failedCount} failed`,
            "warning"
          );
        }
      } else {
        showToast(data.message || "Failed to update system prices", "error");
      }
    } catch (error) {
      console.error("Error saving prices:", error);
      showToast("Network error: " + error.message, "error");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  
  // if (isOnboarding && collectorTax === null) {
  //   return (
  //     <div className="mini-cart-container">
  //       <div className="onboarding-overlay">
  //         <div className="onboarding-modal" style={{ position: "relative" }}>
  //           <button
  //             onClick={() => setIsOnboarding(false)}
  //             style={{
  //               position: "absolute", top: "12px", right: "16px",
  //               background: "none", border: "none", fontSize: "20px",
  //               cursor: "pointer", color: "#fff", lineHeight: 1, opacity: 0.8
  //             }}
  //             title="Close"
  //           >
  //             ×
  //           </button>
  //           <div className="onboarding-header">
  //             <h1>Welcome to Mini Cart!</h1>
  //             <p>Sell CapnoGO™ systems on your website</p>
  //           </div>

  //           <div className="onboarding-content">
  //             <h2>Do you want to collect taxes from customers?</h2>
  //             <p>You can configure tax settings now or update them later</p>

  //             <div className="onboarding-buttons">
  //               <button
  //                 className="btn-primary"
  //                 style={{hover: {backgroundColor: "#e3e3e3", color: "black"}}}
  //                 onClick={() => handleTaxCollectionChoice(true)}
  //               >
  //                 <i className="fas fa-check"></i> Yes, Collect Taxes
  //               </button>
  //               <button
  //                 className="btn-secondary"
  //                 onClick={() => handleTaxCollectionChoice(false)}
  //               >
  //                 <i className="fas fa-times"></i> No, Skip for Now
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }


  // if (isOnboarding && collectorTax === true && !taxSaved  && distributorCountry === null) {
  //   return (
  //     <div className="mini-cart-container">
  //       <div className="onboarding-overlay">
  //         <div className="onboarding-modal">
  //           <div className="onboarding-header">
  //             <h1>Tax Configuration</h1>
  //             <p>Select your operating location</p>
  //           </div>

  //           <div className="onboarding-content">
  //             <h2>Where is your business located?</h2>
  //             <p>This helps us set up the right tax structure for you</p>

  //             <div className="country-selection">
  //               <button
  //                 className="country-btn"
  //                 onClick={() => handleCountrySelect("US")}
  //               >
  //                 <i className="fas fa-flag-usa"></i>
  //                 <span>United States</span>
  //                 <p>Configure state-by-state tax rates</p>
  //               </button>
  //               <button
  //                 className="country-btn"
  //                 onClick={() => handleCountrySelect("OTHER")}
  //               >
  //                 <i className="fas fa-globe"></i>
  //                 <span>Other Country</span>
  //                 <p>Set a single tax percentage</p>
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isOnboarding && collectorTax === true && !taxSaved && distributorCountry !== null) {
  //   return (
  //     <div className="mini-cart-container">
  //       <div className="onboarding-overlay">
  //         <div className="tax-setup-modal">
  //           <div className="tax-setup-header">
  //             <h1 style={{color:"black"}}>Tax Settings</h1>
  //             <p style={{color:"black"}}>
  //               {distributorCountry === "US"
  //                 ? "Configure tax rates for each state"
  //                 : "Set your tax percentage"}
  //             </p>
  //           </div>

  //           <div className="tax-setup-content">
  //             {distributorCountry === "US" ? (
  //               <>
  //                 <p className="tax-note" style={{color:"black"}}>
  //                   <i className="fas fa-info-circle"></i>
  //                   Select the states you operate in and set their tax percentages.
  //                 </p>

  //                 <div className="state-selector">
  //                   <label>Add States</label>
  //                   <select onChange={(e) => {
  //                     if (e.target.value) {
  //                       handleAddState(e.target.value);
  //                       e.target.value = "";
  //                     }
  //                   }}>
  //                     <option value="">-- Select a state --</option>
  //                     {usStates.map(state => (
  //                       <option
  //                         key={state}
  //                         value={state}
  //                         disabled={selectedStates.includes(state)}
  //                       >
  //                         {state}
  //                       </option>
  //                     ))}
  //                   </select>
  //                 </div>

  //                 <div className="selected-states">
  //                   {selectedStates.length > 0 ? (
  //                     <>
  //                       <p style={{ marginTop: "20px", marginBottom: "15px", fontWeight: "600" }}>
  //                         States ({selectedStates.length})
  //                       </p>
  //                       <div className="states-list">
  //                         {selectedStates.map(state => (
  //                           <div key={state} className="state-input">
  //                             <label>{state}</label>
  //                             <div className="input-group">
  //                               <input
  //                                 type="number"
  //                                 min="0"
  //                                 max="100"
  //                                 step="0.1"
  //                                 value={taxSettings[state] || 0}
  //                                 onChange={(e) => handleTaxChange(state, e.target.value)}
  //                                 placeholder="0"
  //                               />
  //                               <span>%</span>
  //                             </div>
  //                             <button
  //                               className="remove-state-btn"
  //                               onClick={() => handleRemoveState(state)}
  //                               type="button"
  //                             >
  //                               <i className="fas fa-trash"></i>
  //                             </button>
  //                           </div>
  //                         ))}
  //                       </div>
  //                     </>
  //                   ) : (
  //                     <p style={{ marginTop: "20px", color: "#666", fontStyle: "italic" }}>
  //                       No states selected yet
  //                     </p>
  //                   )}
  //                 </div>
  //               </>
  //             ) : (
  //               <>
  //                 <p className="tax-note">
  //                   <i className="fas fa-info-circle"></i>
  //                   Enter the tax percentage you want to collect from customers.
  //                 </p>
  //                 <div className="global-tax-input">
  //                   <label>Tax Percentage</label>
  //                   <div className="input-group">
  //                     <input
  //                       type="number"
  //                       min="0"
  //                       max="100"
  //                       step="0.1"
  //                       value={taxSettings.globalTax || 0}
  //                       onChange={(e) => handleTaxChange("globalTax", e.target.value)}
  //                       placeholder="0"
  //                     />
  //                     <span>%</span>
  //                   </div>
  //                 </div>
  //               </>
  //             )}

  //             <div className="tax-buttons">
  //               <button
  //                 className="btn-secondary"
  //                 onClick={() => setDistributorCountry(null)}
  //               >
  //                 <i className="fas fa-arrow-left"></i> Back
  //               </button>
  //               <button
  //                 className="btn-primary"
  //                 onClick={handleCompleteTaxSetup}
  //               >
  //                 <i className="fas fa-check"></i> Complete Setup
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isOnboarding && taxSaved === true) {
  //   return (
  //     <div className="mini-cart-container">
  //       <div className="onboarding-overlay">
  //         <div className="onboarding-modal">
  //           <div className="onboarding-header">
  //             <h1>PayPal Setup</h1>
  //             <p>Enter your PayPal credentials to process payments</p>
  //           </div>

  //           <div className="onboarding-content">
  //             <h2>PayPal Client ID</h2>
  //             <p>Get your PayPal Client ID from your PayPal developer dashboard</p>

  //             <div style={{ marginTop: "20px" }}>
  //               <div style={{ marginBottom: "16px" }}>
  //                 <label style={{ display: "block", marginBottom: "8px", fontWeight: "700", fontSize: "14px", color: "black" }}>
  //                   <i className="fas fa-key"></i> Client ID
  //                 </label>
  //                 <div style={{ position: "relative" }}>
  //                   <input
  //                     type={showPaypalOnboarding ? "text" : "password"}
  //                     value={paymentCredentials.paypal_client_id}
  //                     onChange={(e) => setPaymentCredentials({ ...paymentCredentials, paypal_client_id: e.target.value })}
  //                     placeholder="Enter your PayPal Client ID"
  //                     style={{
  //                       width: "100%",
  //                       padding: "12px",
  //                       paddingRight: "44px",
  //                       border: "2px solid rgb(77, 0, 77)",
  //                       borderRadius: "8px",
  //                       fontSize: "14px",
  //                       boxSizing: "border-box"
  //                     }}
  //                   />
  //                   <button
  //                     type="button"
  //                     onClick={() => setShowPaypalOnboarding(!showPaypalOnboarding)}
  //                     style={{
  //                       position: "absolute",
  //                       right: "12px",
  //                       top: "50%",
  //                       transform: "translateY(-50%)",
  //                       background: "none",
  //                       border: "none",
  //                       cursor: "pointer",
  //                       color: "#666",
  //                       padding: "0",
  //                       fontSize: "14px"
  //                     }}
  //                   >
  //                     <i className={`fas fa-eye${showPaypalOnboarding ? "-slash" : ""}`}></i>
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>

  //             <div style={{ marginTop: "24px", padding: "12px", backgroundColor: "#f3e8ff", borderRadius: "8px", fontSize: "12px", color: "black" }}>
  //               <i className="fas fa-info-circle"></i> Your Client ID is stored securely and never shared. You can update it anytime from settings.
  //             </div>

  //             <div className="onboarding-buttons" style={{ marginTop: "24px" }}>
  //               <button
  //                 className="btn-secondary"
  //                 onClick={() => {
  //                   setPaymentCredentials(prev => ({ ...prev, paypal_client_id: "" }));
  //                   setDistributorCountry(null);
  //                   setCollectorTax(null);
  //                 }}
  //               >
  //                 <i className="fas fa-arrow-left"></i> Back
  //               </button>
  //               <button
  //                 className="btn-primary"
  //                 onClick={handlePaypalSetup}
  //               >
  //                 <i className="fas fa-check"></i> Complete Setup
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  const isPaymentNotConfigured =
    (paymentGateway === "paypal" && !paymentCredentials.paypal_client_id.trim()) ||
    (paymentGateway === "stripe" && (!paymentCredentials.stripe_publishable_key.trim() || !paymentCredentials.stripe_secret_key.trim())) ||
    (paymentGateway === "custom" && !paymentCredentials.custom_gateway_name.trim()) ||
    (paymentGateway === "mollie" && !paymentCredentials.mollie_api_key.trim());

  const isNoProductPriceSet = availableSystems
    .filter(s => s.id !== 135)
    .every(s => !systemPrices[s.id] || parseFloat(systemPrices[s.id]) === 0);

  const isModulePriceNotSet = availableSystems.some(s => s.id === 135) &&
    (!systemPrices[135] || parseFloat(systemPrices[135]) <= 0);

  const showEmbedOverlay = isPaymentNotConfigured || isNoProductPriceSet || isModulePriceNotSet;

  const distributorActions = getDistributorActions(localStorage.getItem("user_id"), () => (window.location.href = "/distributor-dashboard"));

  return (
    <div className="mini-cart-container">
      <div className="mini-cart-dashboard">
        {/* Sidebar */}
        <QuickActionsSidebar actions={distributorActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />

        {/* Main Content */}
        <div className="mini-cart-content">
          <div className="content-header">
            <div className="content-header-text">
              <h1>Mini Cart - Configuration</h1>
              <p>Instructions for setting up the BetterPhysiology  mini shopping cart on your website</p>
            </div>
            <SiteSwitcher />
          </div>

          <div className="settings-grid">
            <div className="tax-settings-section">
              <div className="tax-settings-card">
                <div className="tax-settings-info">
                  <i className="fas fa-percentage"></i>
                  <div>
                    <h3>Taxes</h3>
                    {/* <p>
                      {collectorTax
                        ? `Tax collection enabled`
                        : "Tax collection disabled"}
                        Configure taxes 
                    </p> */}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                        
                  <button
                    className="btn-manage-tax"
                    onClick={() => setShowTaxModal(true)}
                    title="Manage Tax Settings"
                  >
                    <i className="fas fa-cog"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="payment-settings-section">
              <div className="payment-settings-card">
                <div className="payment-settings-info">
                  <i className="fas fa-credit-card"></i>
                  <div>
                    <h3>Payment</h3>
                    {/* <p>Configure Gateway</p> */}
                  </div>
                </div>
                <button
                  className="btn-manage-payment"
                  onClick={() => setShowPaymentModal(true)}
                  title="Configure Payment Settings"
                >
                  <i className="fas fa-cog"></i>
                </button>
              </div>
            </div>

            <div className="pricing-settings-section">
              <div className="pricing-settings-card">
                <div className="pricing-settings-info">
                  <i className="fas fa-tag text-purple"></i>
                  <div>
                    <h3>Products</h3>
                    {/* <p>
                      {Object.keys(systemPrices).length > 0
                        ? `${Object.keys(systemPrices).length} products(s) with custom prices`
                        : "Configure prices "}
                        Configure prices 
                    </p> */}
                  </div>
                </div>
                <button
                  className="btn-manage-pricing"
                  onClick={() => setShowPricesModal(true)}
                  title="Configure prices"
                >
                  <i className="fas fa-cog"></i>
                </button>
              </div>
            </div>
            

            <div className="language-currency-settings-section">
              <div className="language-currency-settings-card">
                <div className="language-currency-settings-info">
                  <i className="fas fa-truck"></i>
                  <div>
                    <h3>Shipping</h3>
                    {/* <p>
                     {shippingSettings.domestic_shipping !== "" || shippingSettings.international_shipping !== ""
                        ? `Domestic: ${getCurrencySymbol(selectedCurrency)}${shippingSettings.domestic_shipping || 0} • Intl: ${getCurrencySymbol(selectedCurrency)}${shippingSettings.international_shipping || 0}`
                        : "Configure shipping rates"}  
                        Configure shipping rates
                    </p> */}
                  </div>
                </div>
                <button
                  className="btn-manage-language-currency"
                  onClick={() => setShowShippingModal(true)}
                  title="Configure shipping rates"
                >
                  <i className="fas fa-cog"></i>
                </button>
              </div>
            </div>

              <div className="discount-settings-card" style={{
                background: "white",
                border: "2px solid #e9d5ff",
                borderRadius: "16px",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 4px 12px rgba(168, 85, 247, 0.08)",
              }}>
                <div className="discount-settings-info" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                  <i className="fas fa-tag" style={{ fontSize: "24px", color: "rgb(77, 0, 77)" }}></i>
                  <div>
                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#1f2937" }}>Discounts</h3>
                  </div>
                </div>
                <Link
                  to={`/distributor/${siteId}/discounts`}
                  className="btn-manage-tax"
                  title="Manage Discount Codes"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fas fa-cog"></i>
                </Link>
              </div>
        
            <div className="discount-settings-card" style={{
                background: "white",
                border: "2px solid #e9d5ff",
                borderRadius: "16px",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 4px 12px rgba(168, 85, 247, 0.08)",
              }}>
                <div className="discount-settings-info" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                  <i className="fas fa-cogs" style={{ fontSize: "24px", color: "rgb(77, 0, 77)" }}></i>
                  <div>
                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#1f2937" }}>Site Settings</h3>
                  </div>
                </div>
                <Link
                  to={`/distributor/${siteId}/site-settings`}
                  className="btn-manage-tax"
                  title="Manage Site Settings"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fas fa-cog"></i>
                </Link>
              </div>

          

            {/* <div className="discount-settings-card" style={{
                background: "white",
                border: "2px solid #e9d5ff",
                borderRadius: "16px",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 4px 12px rgba(168, 85, 247, 0.08)",
              }}>
                <div className="discount-settings-info" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                  <i className="fas fa-boxes" style={{ fontSize: "24px", color: "rgb(77, 0, 77)" }}></i>
                  <div>
                    <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#1f2937" }}>Manage Bundles</h3>
                  </div>
                </div>
                <Link
                  to="/distributor-products"
                  className="btn-manage-tax"
                  title="Manage Products"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fas fa-cog"></i>
                </Link>
              </div> */}

            <div className="language-settings-section">
              <div className="language-settings-card">
                <div className="language-settings-info">
                  <i className="fas fa-language"></i>
                  <div>
                    <h3>Language</h3>
                    {/* <p>Configure Language</p> */}
                  </div>
                </div>
                <button
                  className="btn-manage-language"
                  onClick={() => {
                    setOriginalLanguage(selectedLanguage);
                    setShowLanguageModal(true);
                  }}
                  title="Configure Language"
                >
                  <i className="fas fa-cog"></i>
                </button>
              </div>
            </div>

            <div className="currency-settings-section">
              <div className="currency-settings-card">
                <div className="currency-settings-info">
                  <i className="fas fa-dollar-sign"></i>
                  <div>
                    <h3>Currency</h3>
                    {/* <p>Configure Currency</p> */}
                  </div>
                </div>
                <button
                  className="btn-manage-currency"
                  onClick={() => {
                    setOriginalCurrency(selectedCurrency);
                    setShowCurrencyModal(true);
                  }}
                  title="Configure Currency"
                >
                  <i className="fas fa-cog"></i>
                </button>
              </div>
            </div>

            <div className="shopping-cart-settings-section">
              <div className="shopping-cart-settings-card">
                <div className="shopping-cart-settings-info">
                  <i className="fas fa-shopping-cart"></i>
                  <div>
                    <h3>View</h3>
                    {/* <p>Open the shopping cart</p> */}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    className="btn-open-cart"
                    onClick={() => {
                      navigator.clipboard.writeText(`http://cart.capno.us/shopping/${siteId}`);
                      showToast("Shopping cart link copied to clipboard!", "success");
                    }}
                    title="Copy the shopping cart link"
                  >
                    <i className="fas fa-copy"></i>
                  </button>
                  <button
                    className="btn-open-cart"
                    onClick={() => window.open(`http://cart.capno.us/shopping/${siteId}`, "_blank")}
                    title="Open the shopping cart"
                  >
                    <i className="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="shopping-cart-settings-section">
              <div className="shopping-cart-settings-card">
                <div className="shopping-cart-settings-info">
                  <i className="fas fa-headset"></i>
                  <div>
                    <h3>Support</h3>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    className="btn-open-cart"
                    onClick={() => {
                      navigator.clipboard.writeText(`https://capno.us/${siteId}`);
                      showToast("Support link copied to clipboard!", "success");
                    }}
                    title="Copy the support link"
                  >
                    <i className="fas fa-copy"></i>
                  </button>
                  <button
                    className="btn-open-cart"
                    onClick={() => window.open(`https://capno.us/${siteId}`, "_blank")}
                    title="Open the support site"
                  >
                    <i className="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
            </div>


          </div>

          <div className="implementation-section" >
            <h2>Embed the Mini Cart by pasting this code into your website (for developers).</h2>

            {/* Embed Section */}
            <div style={{ marginBottom: "30px",position:"relative",height:showEmbedOverlay?"240px":"auto"}}>
              {/* <p style={{ marginBottom: "12px", fontWeight: "600" }}></p> */}
              {/* <p style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>Embed the Mini Cart by copying and pasting this code into your website:</p> */}
              <div className="code-block-mini" style={{wordBreak: "break-all",height:showEmbedOverlay?"240px":"auto"}}>
                <button
                  className="copy-btn-mini"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `<iframe src="http://cart.capno.us/shopping/${siteId}" width="100%" height="600" style="border: none; border-radius: 8px;"></iframe>`
                    );
                    showToast("Embed code copied to clipboard!", "success");
                  }}
                >
                  <i className="fas fa-copy"></i> Click to copy this code
                </button>
                <pre style={{marginTop: "20px", wordBreak: "break-word", width: "100%"}}>{`<iframe src="http://cart.capno.us/shopping/${siteId}" width="100%" height="600" style="border: none; border-radius: 8px;"></iframe>`}</pre>
              </div>
                {/* Setup Required Overlay */}
            {showEmbedOverlay && (
              
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "linear-gradient(135deg, rgba(124, 58, 237, 0.15), rgba(99, 102, 241, 0.15))",
                backdropFilter: "blur(10px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "16px",
                zIndex: 10,
                padding: "24px",
                textAlign: "center"
              }}>
                <i className="fas fa-lock" style={{ fontSize: "28px", color: "#7c3aed" }}></i>
                <h3 style={{ color: "#fff", paddingTop: "1rem", marginBottom: "10px", fontWeight: "700", fontSize: "18px" }}>
                  Setup Required
                </h3>
                <p style={{ color: "#fff", maxWidth: "420px", lineHeight: "1.7", marginBottom: "20px", fontSize: "14px" }}>
                  Please complete your <strong style={{ color: "#fff" }}>Payment Settings</strong>, set at least one{" "}
                  <strong style={{ color: "#fff" }}>Product Pricing</strong>, and set your{" "}
                  <strong style={{ color: "#fff" }}>Module</strong> price{" "}
                  in order to copy or use the embed code.
                </p>
                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
                  {isPaymentNotConfigured && (
                    <button
                      className="btn-primary"
                      onClick={() => setShowPaymentModal(true)}
                      style={{ fontSize: "14px" }}
                    >
                      <i className="fas fa-credit-card" style={{ marginRight: "6px" }}></i>
                      Set Up Payment
                    </button>
                  )}
                  {(isNoProductPriceSet || isModulePriceNotSet) && (
                    <button
                      className="btn-primary"
                      onClick={() => setShowPricesModal(true)}
                      style={{ fontSize: "14px" }}
                    >
                      <i className="fas fa-tag" style={{ marginRight: "6px" }}></i>
                      Set Product Prices
                    </button>
                  )}
                </div>
              </div>
            )}
            </div>

            {/* Direct URL Section */}
            {/* <div>
              <p style={{ marginBottom: "12px", fontWeight: "600" }}>Option 2: Direct Mini-Cart URL</p>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>Share this URL directly with customers:</p>
              <div className="code-block-mini">
                <button
                  className="copy-btn-mini"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `http://cart.capno.us/shopping/${siteId}`
                    );
                    showToast("Mini-Cart URL copied to clipboard!", "success");
                  }}
                >
                  <i className="fas fa-copy"></i> Copy URL
                </button>
                <pre>{`http://cart.capno.us/shopping/${siteId}`}</pre>
              </div>
            </div> */}

          
          </div>
        </div>
      </div>

      {/* Tax Settings Modal */}
      <Modal isOpen={showTaxModal} toggle={() => setShowTaxModal(false)} size="lg" centered>
        <ModalHeader className="text-white" toggle={() => setShowTaxModal(false)}>
          <i className="fas fa-percentage"></i> Tax Settings
        </ModalHeader>
        <ModalBody>
          {distributorCountry === "231" ? (
            <>
              <p><strong>State Tax Rates</strong></p>

              <div className="state-selector">
                <label>Add States</label>
                <select onChange={(e) => {
                  if (e.target.value) {
                    handleAddState(e.target.value);
                    e.target.value = "";
                  }
                }}>
                  <option value="">-- Select a state --</option>
                  {usStates.map(state => (
                    <option
                      key={state}
                      value={state}
                      disabled={selectedStates.includes(state)}
                    >
                      {state}
                    </option>
                  ))}
                </select>
              </div>

              <div className="selected-states">
                {selectedStates.length > 0 ? (
                  <div className="states-list" style={{ marginTop: "15px" }}>
                    {selectedStates.map(state => (
                      <div key={state} className="state-input">
                        <label>{state}</label>
                        <div className="input-group">
                          <input
                            type="number"
                            min="0"
                            max="100"
                            step="0.1"
                            value={taxSettings[state] || 0}
                            onChange={(e) => handleTaxChange(state, e.target.value)}
                          />
                          <span>%</span>
                        </div>
                        <button
                          className="remove-state-btn"
                          onClick={() => handleRemoveState(state)}
                          type="button"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ marginTop: "15px", color: "#666", fontStyle: "italic" }}>
                    No states selected yet
                  </p>
                )}
              </div>
            </>
          ) : (
            <>
              <p><strong>Global Tax Percentage</strong></p>
              <div className="global-tax-modal">
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.1"
                    value={taxSettings.globalTax}
                    onChange={(e) => handleTaxChange("globalTax", e.target.value)}
                  />
                  <span>%</span>
                </div>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="btn-secondary"
            onClick={() => setShowTaxModal(false)}
          >
            Close
          </button>
          <button
            className="btn-primary"
            onClick={async () => {
              try {
                const response = await fetch(`${API_URL}/distributor/tax-settings/${siteId}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ country: distributorCountry, states: buildTaxStatesPayload() })
                });
                const data = await response.json();
                if (data.status) {
                  showToast("Tax settings updated successfully!", "success");
                  setShowTaxModal(false);
                } else {
                  showToast(data.message || "Failed to update tax settings", "error");
                }
              } catch (err) {
                console.error("Error saving tax settings:", err);
                showToast("Failed to update tax settings", "error");
              }
            }}
          >
            Save Changes 
          </button>
        </ModalFooter>
      </Modal>

      {/* Currency Settings Modal */}
      <Modal isOpen={showCurrencyModal} toggle={() => { setShowCurrencyModal(false); setSelectedCurrency(originalCurrency); }} centered>
        <ModalHeader className="text-white" toggle={() => { setShowCurrencyModal(false); setSelectedCurrency(originalCurrency); }}>
          <i className="fas fa-dollar-sign"></i> Currency
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "12px", fontSize: "14px", fontWeight: "600", color: "black" }}>
              <i className="fas fa-dollar-sign"></i> Select Currency
            </label>
            <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                border: "2px solid rgb(77, 0, 77)",
                borderRadius: "8px",
                fontSize: "14px",
                boxSizing: "border-box",
                color: "black",
                backgroundColor: "white"
              }}
            >
              <option value="USD">USD - US Dollar</option>
              <option value="EUR">EUR - Euro</option>
              <option value="GBP">GBP - British Pound</option>
              <option value="JPY">JPY - Japanese Yen</option>
              <option value="CNY">CNY - Chinese Yuan</option>
              <option value="INR">INR - Indian Rupee</option>
              <option value="BRL">BRL - Brazilian Real</option>
              <option value="MXN">MXN - Mexican Peso</option>
              <option value="CAD">CAD - Canadian Dollar</option>
              <option value="AUD">AUD - Australian Dollar</option>
              <option value="NZD">NZD - New Zealand Dollar</option>
              <option value="CHF">CHF - Swiss Franc</option>
              <option value="SGD">SGD - Singapore Dollar</option>
              <option value="HKD">HKD - Hong Kong Dollar</option>
              <option value="KRW">KRW - South Korean Won</option>
              <option value="THB">THB - Thai Baht</option>
              <option value="MYR">MYR - Malaysian Ringgit</option>
              <option value="IDR">IDR - Indonesian Rupiah</option>
              <option value="PHP">PHP - Philippine Peso</option>
              <option value="VND">VND - Vietnamese Dong</option>
              <option value="ZAR">ZAR - South African Rand</option>
              <option value="TRY">TRY - Turkish Lira</option>
              <option value="RUB">RUB - Russian Ruble</option>
              <option value="PLN">PLN - Polish Zloty</option>
              <option value="CZK">CZK - Czech Koruna</option>
              <option value="HUF">HUF - Hungarian Forint</option>
              <option value="RON">RON - Romanian Leu</option>
              <option value="BGN">BGN - Bulgarian Lev</option>
              <option value="HRK">HRK - Croatian Kuna</option>
              <option value="SEK">SEK - Swedish Krona</option>
              <option value="NOK">NOK - Norwegian Krone</option>
              <option value="DKK">DKK - Danish Krone</option>
              <option value="ILS">ILS - Israeli Shekel</option>
              <option value="AED">AED - UAE Dirham</option>
              <option value="SAR">SAR - Saudi Riyal</option>
              <option value="ARS">ARS - Argentine Peso</option>
              <option value="CLP">CLP - Chilean Peso</option>
              <option value="COP">COP - Colombian Peso</option>
              <option value="PEN">PEN - Peruvian Sol</option>
              <option value="UYU">UYU - Uruguayan Peso</option>
              <option value="EGP">EGP - Egyptian Pound</option>
              <option value="NGN">NGN - Nigerian Naira</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn-secondary"
            onClick={() => { setShowCurrencyModal(false); setSelectedCurrency(originalCurrency); }}
          >
            Close
          </button>
          <button
            className="btn-primary"
            onClick={async () => {
              setSavingCurrency(true);
              try {
                const response = await fetch(`${API_URL}/update-distributor-language-currency/${siteId}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ selected_currency: selectedCurrency , selected_language: selectedLanguage})
                });
                const data = await response.json();
                if (data.status) {
                  setOriginalCurrency(selectedCurrency);
                  setShowCurrencyModal(false);
                  showToast("Currency updated successfully!", "success");
                  // The API resets the site's prices when the currency
                  // changes — reload them so the modal opens with them.
                  setSystemPrices({});
                  setShowPricesModal(true);
                  fetchPricesFromAPI();
                } else {
                  showToast(data.message || "Failed to save currency", "error");
                }
              } catch (error) {
                console.error("Error saving currency:", error);
                showToast("Failed to save currency", "error");
              } finally {
                setSavingCurrency(false);
              }
            }}
            disabled={savingCurrency}
          >
            {savingCurrency ? (
              <><i className="fas fa-spinner fa-spin"></i> Saving...</>
            ) : (
              "Save Changes"
            )}
          </button>
        </ModalFooter>
      </Modal>

      {/* System Pricing Modal */}
      <Modal isOpen={showPricesModal} toggle={() => setShowPricesModal(false)} size="lg" centered>
        <ModalHeader className="text-white" toggle={() => setShowPricesModal(false)}>
          <i className="fas fa-tag"></i> System Pricing ({selectedCurrency})
        </ModalHeader>
        <ModalBody style={{ maxHeight: "500px", overflowY: "auto" }}>
          {loadingPrices ? (
            <div style={{ textAlign: "center", padding: "40px", color: "black" }}>
              <div style={{ marginBottom: "20px" }}>
                <i className="fas fa-spinner fa-spin" style={{ fontSize: "48px", color: "rgb(77, 0, 77)" }}></i>
              </div>
              <p style={{ fontSize: "16px", fontWeight: "600" }}>Loading prices...</p>
            </div>
          ) : (
            <>
              {!isNoProductPriceSet && isModulePriceNotSet && (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  color: "#b91c1c",
                  borderRadius: "8px",
                  padding: "12px 16px",
                  marginBottom: "16px",
                  fontSize: "13px",
                  fontWeight: "600",
                }}>
                  <i className="fas fa-exclamation-triangle"></i>
                  Module price is required. Please set a price for the Modules.
                </div>
              )}
              <p style={{ marginBottom: "12px", fontWeight: "600", color: "black" }}>
                Set prices for each product in your mini cart:
              </p>
              <p style={{ marginBottom: "20px", fontSize: "13px", color: "#6b7280" }}>
         
                <Link to="/distributor-products" style={{ color: "rgb(77, 0, 77)", fontWeight: "600", textDecoration: "underline" }}>
                  Click here 
                </Link> {" "}                
                to create and edit unique products.
              </p>
              <div className="pricing-list">
                {availableSystems
                  .filter(system => !(system.category === 22 && (system.id < 130 || system.id > 134)))
                  .map(system => (
                  <div key={system.id} className="pricing-item">
                    <div className="pricing-item-info">
                      <label style={{ fontWeight: "600", marginBottom: "8px", display: "flex", alignItems: "center", gap: "8px", color: "black" }}>
                        {system.name}
                        {system.category === 22 &&
                          parseFloat(systemPrices[system.id] || 0) > 0 &&
                          parseFloat(systemPrices[135] || 0) > 0 && (
                            <button
                              type="button"
                              title="Copy product link"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `http://cart.capno.us/shopping/${siteId}/${system.id}`
                                );
                                showToast("Shopping cart link copied to clipboard!", "success");
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "rgb(77, 0, 77)",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i className="fas fa-copy"></i> Copy Link
                            </button>
                          )}
                      </label>
                    </div>
                    {system.id >= 130 && system.id <= 134 && (
                      <label
                        className="toggle-switch"
                        title={systemEnabled[system.id] !== false ? "Disable system" : "Enable system"}
                      >
                        <input
                          type="checkbox"
                          checked={systemEnabled[system.id] !== false}
                          onChange={() => handleToggleEnabled(system.id)}
                        />
                        <span className="toggle-slider"></span>
                      </label>
                    )}
                    <div
                      className="pricing-input-group"
                      style={{ opacity: systemEnabled[system.id] === false ? 0.5 : 1 }}
                    >
                      <span>{getCurrencySymbol(selectedCurrency)}</span>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={systemPrices[system.id]}
                        onChange={(e) => handlePriceChange(system.id, e.target.value)}
                        placeholder="0.00"
                        disabled={systemEnabled[system.id] === false}
                        style={{
                          width: "120px",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          fontSize: "14px",
                          color: "black"
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="btn-secondary"
            onClick={() => setShowPricesModal(false)}
          >
            Close
          </button>
          <button
            className="btn-primary"
            onClick={handleSavePrices}
          >
            <i className="fas fa-save"></i> Save Prices
          </button>
        </ModalFooter>
      </Modal>

      {/* Payment Settings Modal */}
      <Modal isOpen={showPaymentModal} toggle={() => setShowPaymentModal(false)} size="lg" centered>
        <ModalHeader className="text-white" toggle={() => setShowPaymentModal(false)}>
          <i className="fas fa-credit-card"></i> Payment Settings
        </ModalHeader>
        <ModalBody>
          {/* Gateway Selection */}
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "12px", fontSize: "14px", fontWeight: "600", color: "black" }}>
              Select Payment Gateway
            </label>
            <select
              value={paymentGateway}
              onChange={(e) => {
                setPaymentGateway(e.target.value);
                setPaymentCredentials({
                  paypal_client_id: "",
                  stripe_publishable_key: "",
                  stripe_secret_key: "",
                  custom_gateway_name: "",
                  mollie_api_key: "",
                });
              }}
              style={{
                width: "100%",
                padding: "12px",
                border: "2px solid rgb(77, 0, 77)",
                borderRadius: "8px",
                fontSize: "14px",
                boxSizing: "border-box",
                color: "black",
                backgroundColor: "white"
              }}
            >
              <option value="stripe">Stripe</option>
              <option value="paypal">PayPal</option>
              <option value="mollie">Mollie</option>
              <option value="custom">Custom Gateway</option>
            </select>

            {paymentGateway === "stripe" && (
              <div style={{ marginTop: "10px", fontSize: "13px" }}>
                <a
                  href="https://docs.stripe.com/keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgb(77, 0, 77)", textDecoration: "underline" }}
                >
                  <i className="fas fa-external-link-alt" style={{ marginRight: "5px" }}></i>
                  Click here to read how to obtain credentials for Stripe
                </a>
              </div>
            )}

            {paymentGateway === "mollie" && (
              <div style={{ marginTop: "10px", fontSize: "13px" }}>
                <a
                  href="https://docs.mollie.com/docs/getting-started"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgb(77, 0, 77)", textDecoration: "underline" }}
                >
                  <i className="fas fa-external-link-alt" style={{ marginRight: "5px" }}></i>
                  Click here to read how to obtain credentials for mollie
                </a>
              </div>
            )}
            {paymentGateway === "paypal" && (
              <div style={{ marginTop: "10px", fontSize: "13px" }}>
                <a
                  href="https://developer.paypal.com/docs/multiparty/create-account/#credential-reference"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgb(77, 0, 77)", textDecoration: "underline" }}
                >
                  <i className="fas fa-external-link-alt" style={{ marginRight: "5px" }}></i>
                  Click here to read how to obtain credentials for PayPal
                </a>
              </div>
            )}

            {paymentGateway === "custom" && (
              <div style={{ marginTop: "10px", fontSize: "13px", color: "rgb(77, 0, 77)", fontStyle: "italic" }}>
                <i className="fas fa-info-circle" style={{ marginRight: "5px" }}></i>
                Please specify the gateway you want us to enable for you.
              </div>
            )}
          </div>

          {/* Stripe Credentials */}
          {paymentGateway === "stripe" && (
            <>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
                  <i className="fas fa-key"></i> Publishable Key
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showStripePublishable ? "text" : "password"}
                    value={paymentCredentials.stripe_publishable_key}
                    onChange={(e) => setPaymentCredentials({ ...paymentCredentials, stripe_publishable_key: e.target.value })}
                    placeholder="pk_live_..."
                    style={{
                      width: "100%",
                      padding: "12px",
                      paddingRight: "44px",
                      border: "2px solid rgb(77, 0, 77)",
                      borderRadius: "8px",
                      fontSize: "14px",
                      boxSizing: "border-box",
                      color: "black"
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowStripePublishable(!showStripePublishable)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#666",
                      padding: "0",
                      fontSize: "14px"
                    }}
                  >
                    <i className={`fas fa-eye${showStripePublishable ? "-slash" : ""}`}></i>
                  </button>
                </div>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
                  <i className="fas fa-key"></i> Secret Key
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showStripeSecret ? "text" : "password"}
                    value={paymentCredentials.stripe_secret_key}
                    onChange={(e) => setPaymentCredentials({ ...paymentCredentials, stripe_secret_key: e.target.value })}
                    placeholder="sk_live_..."
                    style={{
                      width: "100%",
                      padding: "12px",
                      paddingRight: "44px",
                      border: "2px solid rgb(77, 0, 77)",
                      borderRadius: "8px",
                      fontSize: "14px",
                      boxSizing: "border-box",
                      color: "black"
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowStripeSecret(!showStripeSecret)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#666",
                      padding: "0",
                      fontSize: "14px"
                    }}
                  >
                    <i className={`fas fa-eye${showStripeSecret ? "-slash" : ""}`}></i>
                  </button>
                </div>
              </div>
            </>
          )}

          {/* PayPal Credentials */}
          {paymentGateway === "paypal" && (
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
                <i className="fas fa-key"></i> Client ID
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPaypalClientId ? "text" : "password"}
                  value={paymentCredentials.paypal_client_id}
                  onChange={(e) => setPaymentCredentials({ ...paymentCredentials, paypal_client_id: e.target.value })}
                  placeholder="Enter your PayPal Client ID"
                  style={{
                    width: "100%",
                    padding: "12px",
                    paddingRight: "44px",
                    border: "2px solid rgb(77, 0, 77)",
                    borderRadius: "8px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    color: "black"
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPaypalClientId(!showPaypalClientId)}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#666",
                    padding: "0",
                    fontSize: "14px"
                  }}
                >
                  <i className={`fas fa-eye${showPaypalClientId ? "-slash" : ""}`}></i>
                </button>
              </div>
            </div>
          )}

          {/* Mollie Credentials */}
          {paymentGateway === "mollie" && (
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
                <i className="fas fa-key"></i> Mollie API Key
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showMollieApiKey ? "text" : "password"}
                  value={paymentCredentials.mollie_api_key}
                  onChange={(e) => setPaymentCredentials({ ...paymentCredentials, mollie_api_key: e.target.value })}
                  placeholder="live_..."
                  style={{
                    width: "100%",
                    padding: "12px",
                    paddingRight: "44px",
                    border: "2px solid rgb(77, 0, 77)",
                    borderRadius: "8px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    color: "black"
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowMollieApiKey(!showMollieApiKey)}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#666",
                    padding: "0",
                    fontSize: "14px"
                  }}
                >
                  <i className={`fas fa-eye${showMollieApiKey ? "-slash" : ""}`}></i>
                </button>
              </div>
            </div>
          )}

          {/* Custom Gateway */}
          {paymentGateway === "custom" && (
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
                <i className="fas fa-edit"></i> Gateway Name
              </label>
              <input
                type="text"
                value={paymentCredentials.custom_gateway_name}
                onChange={(e) => setPaymentCredentials({ ...paymentCredentials, custom_gateway_name: e.target.value })}
                placeholder="e.g., Square, 2Checkout, etc."
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid rgb(77, 0, 77)",
                  borderRadius: "8px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                  color: "black"
                }}
              />
            </div>
          )}

          <div style={{ padding: "12px", backgroundColor: "#f3e8ff", borderRadius: "8px", fontSize: "13px", color: "black" }}>
            <i className="fas fa-info-circle"></i> {" "}
            Your payment credentials are stored securely. You can update them anytime from here.
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn-secondary"
            onClick={() => setShowPaymentModal(false)}
          >
            Close
          </button>
          <button
            className="btn-primary"
            onClick={handleSavePaymentSettings}
            disabled={savingPayment}
          >
            {savingPayment ? (
              <><i className="fas fa-spinner fa-spin"></i> Saving...</>
            ) : (
              "Save Changes"
            )}
          </button>
        </ModalFooter>
      </Modal>

      {/* Language Settings Modal */}
      <Modal isOpen={showLanguageModal} toggle={() => { setShowLanguageModal(false); setSelectedLanguage(originalLanguage); }} centered>
        <ModalHeader className="text-white" toggle={() => { setShowLanguageModal(false); setSelectedLanguage(originalLanguage); }}>
          <i className="fas fa-language"></i> Language
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "12px", fontSize: "14px", fontWeight: "600", color: "black" }}>
              <i className="fas fa-language"></i> Select Language
            </label>
            <select
              value={selectedLanguage}
              onChange={(e) => setSelectedLanguage(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                border: "2px solid rgb(77, 0, 77)",
                borderRadius: "8px",
                fontSize: "14px",
                boxSizing: "border-box",
                color: "black",
                backgroundColor: "white"
              }}
            >
              <option value="en">English</option>
              <option value="es">Español (Spanish)</option>
              <option value="fr">Français (French)</option>
              <option value="de">Deutsch (German)</option>
              <option value="it">Italiano (Italian)</option>
              <option value="pt">Português (Portuguese)</option>
              <option value="pt-BR">Português Brasileiro (Brazilian Portuguese)</option>
              <option value="nl">Nederlands (Dutch)</option>
              <option value="pl">Polski (Polish)</option>
              <option value="ru">Русский (Russian)</option>
              <option value="ja">日本語 (Japanese)</option>
              <option value="zh-Hans">简体中文 (Simplified Chinese)</option>
              <option value="zh-Hant">繁體中文 (Traditional Chinese)</option>
              <option value="ko">한국어 (Korean)</option>
              <option value="ar">العربية (Arabic)</option>
              <option value="he">עברית (Hebrew)</option>
              <option value="tr">Türkçe (Turkish)</option>
              <option value="th">ไทย (Thai)</option>
              <option value="vi">Tiếng Việt (Vietnamese)</option>
              <option value="id">Bahasa Indonesia (Indonesian)</option>
              <option value="fil">Filipino</option>
              <option value="sv">Svenska (Swedish)</option>
              <option value="no">Norsk (Norwegian)</option>
              <option value="da">Dansk (Danish)</option>
              <option value="fi">Suomi (Finnish)</option>
              <option value="cs">Čeština (Czech)</option>
              <option value="hu">Magyar (Hungarian)</option>
              <option value="ro">Română (Romanian)</option>
              <option value="bg">Български (Bulgarian)</option>
              <option value="hr">Hrvatski (Croatian)</option>
              <option value="el">Ελληνικά (Greek)</option>
              <option value="sk">Slovenčina (Slovak)</option>
              <option value="sl">Slovenščina (Slovenian)</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn-secondary"
            onClick={() => { setShowLanguageModal(false); setSelectedLanguage(originalLanguage); }}
          >
            Close
          </button>
          <button
            className="btn-primary"
            onClick={async () => {
              setSavingLanguage(true);
              try {
                const response = await fetch(`${API_URL}/update-distributor-language-currency/${siteId}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ selected_language: selectedLanguage, selected_currency: selectedCurrency })
                });
                const data = await response.json();
                if (data.status) {
                  setOriginalLanguage(selectedLanguage);
                  setOriginalCurrency(selectedCurrency);
                  setShowLanguageModal(false);
                  showToast("Language updated successfully!", "success");
                  if (data.prices_reset) fetchPricesFromAPI();
                } else {
                  showToast(data.message || "Failed to save language", "error");
                }
              } catch (error) {
                console.error("Error saving language:", error);
                showToast("Failed to save language", "error");
              } finally {
                setSavingLanguage(false);
              }
            }}
            disabled={savingLanguage}
          >
            {savingLanguage ? (
              <><i className="fas fa-spinner fa-spin"></i> Saving...</>
            ) : (
              "Save Changes"
            )}
          </button>
        </ModalFooter>
      </Modal>

      {/* Shipping Settings Modal */}
      <Modal isOpen={showShippingModal} toggle={() => setShowShippingModal(false)} centered>
        <ModalHeader className="text-white" toggle={() => setShowShippingModal(false)}>
          <i className="fas fa-truck"></i> Shipping Settings
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
              <i className="fas fa-home"></i> Domestic Shipping Rate ({getCurrencySymbol(selectedCurrency)})
            </label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <span style={{ position: "absolute", left: "12px", color: "#666", fontWeight: "600" }}>
                {getCurrencySymbol(selectedCurrency)}
              </span>
              <input
                type="number"
                min="0"
                step="1"
                value={shippingSettings.domestic_shipping}
                onChange={(e) => setShippingSettings(prev => ({ ...prev, domestic_shipping: e.target.value }))}
                placeholder="0.00"
                style={{
                  width: "100%",
                  padding: "12px 12px 12px 36px",
                  border: "2px solid rgb(77, 0, 77)",
                  borderRadius: "8px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                  color: "black"
                }}
              />
            </div>
            <p style={{ marginTop: "6px", fontSize: "12px", color: "#666" }}>Flat rate charged for orders shipped within your country.</p>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "black" }}>
              <i className="fas fa-globe"></i> International Shipping Rate ({getCurrencySymbol(selectedCurrency)})
            </label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <span style={{ position: "absolute", left: "12px", color: "#666", fontWeight: "600" }}>
                {getCurrencySymbol(selectedCurrency)}
              </span>
              <input
                type="number"
                min="0"
                step="1"
                value={shippingSettings.international_shipping}
                onChange={(e) => setShippingSettings(prev => ({ ...prev, international_shipping: e.target.value }))}
                placeholder="0.00"
                style={{
                  width: "100%",
                  padding: "12px 12px 12px 36px",
                  border: "2px solid rgb(77, 0, 77)",
                  borderRadius: "8px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                  color: "black"
                }}
              />
            </div>
            <p style={{ marginTop: "6px", fontSize: "12px", color: "#666" }}>Flat rate charged for orders shipped internationally.</p>
          </div>

          <div style={{ padding: "12px", backgroundColor: "#f3e8ff", borderRadius: "8px", fontSize: "13px", color: "black" }}>
            <i className="fas fa-info-circle"></i>{" "}
            Set flat shipping rates for domestic and international orders. Enter 0 for free shipping.
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn-secondary" onClick={() => setShowShippingModal(false)}>
            Close
          </button>
          <button className="btn-primary" onClick={handleSaveShippingSettings} disabled={savingShipping}>
            {savingShipping ? (
              <><i className="fas fa-spinner fa-spin"></i> Saving...</>
            ) : (
              "Save Changes"
            )}
          </button>
        </ModalFooter>
      </Modal>

      {/* No Devices Modal */}
      <Modal isOpen={txnLoaded && txnStats?.device?.length === 0} centered size="md">
        <ModalBody style={{ textAlign: "center", padding: "52px 40px" }}>
          <div style={{
            width: "80px", height: "80px", borderRadius: "50%",
            background: "linear-gradient(135deg, #f3e8ff, #ede9fe)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 24px"
          }}>
            <i className="fas fa-box-open" style={{ fontSize: "36px", color: "#7c3aed" }}></i>
          </div>
          <h4 style={{ fontWeight: "700", color: "#1f2937", marginBottom: "12px", fontSize: "22px" }}>
            No Devices Yet 
          </h4>
          <p style={{ color: "#6b7280", fontSize: "15px", lineHeight: "1.7", marginBottom: "32px", maxWidth: "100%", margin: "0 auto 32px" }}>
            There are no devices in your inventory. Please submit a request to purchase your first set of inventory items to initialize your shopping cart.
          </p>
         <div style={{display:"flex",justifyContent:"center",gap:"12px"}}>
           <button
            className="btn-secondary"
            onClick={() => navigate("/distributor-dashboard")}
            style={{ padding: "12px 32px", fontSize: "15px", borderRadius: "8px" }}
          >
            <i className="fas fa-arrow-left" style={{ marginRight: "8px" }}></i>
            Back to Dashboard
          </button>
         </div>
        </ModalBody>
      </Modal>



      {/* Toast Notification */}
      {toastMessage && (
        <Toast
          isOpen={!!toastMessage}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 9999,
            backgroundColor: toastType === "success" ? "#10b981" : toastType === "error" ? "#ef4444" : "#f59e0b"
          }}
        >
          <ToastBody style={{ color: "white", fontWeight: "600" }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      )}
    </div>
  );
};

export default MiniCart;
